export default __webpack_public_path__ + "static/media/CHRONIC-ASTHMA.80673e44.png";